import styles from "./Info.module.css";

export const Info = ({info}) => {
	if (!info) return null;

	const items = [
		{
			key: "version",
			label: "Inventory Version",
			value: info.version,
		},
		{
			key: "items",
			label: "Items",
			value: info.items?.toLocaleString(),
		},
		{
			key: "attrs",
			label: "Attributes",
			value: info.attrs?.toLocaleString(),
		},
		{
			key: "updated",
			label: "Updated",
			value: info.updated,
		},
	];

	return (
		<div className={styles.infoWrapper}>
			{items.map(item => (
				<div key={item.key} className={styles.item}>
					<strong>{item.label}:</strong>
					<span>{item.value}</span>
				</div>
			))}
		</div>
	);
};
